import React, { useState, Fragment } from 'react';

import axios from 'axios';
import Cookies from 'js-cookie';

import {
  TextField,
  Button,
  Modal,
  Backdrop,
  Fade,
  FormControl,
  InputLabel,
  Select,
} from '@material-ui/core';

import { useSnackbar } from 'notistack';

import AddIcon from '@material-ui/icons/Add';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: 'none',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  marginB: {
    marginBottom: '1rem',
  },
  marginR: {
    marginRight: '1rem',
  },
}));

export default function CreateSubCategoryModal(props) {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [category, setCategory] = useState('');
  const [description, setDescription] = useState();
  const [isActive, setIsActive] = useState(true);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCreate = async (e) => {
    e.preventDefault();

    const token = Cookies.get('jwt');
    const subcategory = {
      name,
      category,
      description,
      isActive,
    };

    await axios
      .post(`${process.env.REACT_APP_API}/subcategories`, subcategory, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        setOpen(false);
        window.location.reload();
      })
      .catch((err) => {
        enqueueSnackbar('Une erreur est survenue', {
          variant: 'error',
        });
      });
  };

  return (
    <>
      <Button
        type="button"
        variant="contained"
        color="primary"
        onClick={handleOpen}
        startIcon={<AddIcon />}
      >
        Nouveau
      </Button>
      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h2>Création d'une sous-rubrique</h2>
            <form className={classes.form} onSubmit={handleCreate}>
              <TextField
                className={classes.marginB}
                id="name"
                label="Nom"
                type="text"
                value={name}
                variant="outlined"
                onChange={(e) => setName(e.target.value)}
              />
              <FormControl variant="outlined" className={classes.marginB}>
                <InputLabel>Rubrique principale</InputLabel>
                <Select
                  native
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  label="Catégorie principale"
                >
                  <option value />
                  {props.data.map((cat, index) => (
                    <option key={index} value={cat._id}>
                      {cat.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl variant="outlined" className={classes.marginB}>
                <InputLabel>Actif</InputLabel>
                <Select
                  native
                  value={isActive}
                  onChange={(e) => setIsActive(e.target.value)}
                  label="Actif"
                >
                  <option value>Actif</option>
                  <option value={false}>Inactif</option>
                </Select>
              </FormControl>
              <TextField
                className={classes.marginB}
                id="desciption"
                label="Description"
                type="text"
                variant="outlined"
                multiline
                fullWidth
                onChange={(e) => setDescription(e.target.value)}
              />
              <Button variant="contained" color="primary" type="submit" fullWidth>
                Créer
              </Button>
            </form>
          </div>
        </Fade>
      </Modal>
    </>
  );
}
